var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import TableBody from '@material-ui/core/TableBody';
import { Table } from '@material-ui/core';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
var DynamicSummaryList = /** @class */ (function (_super) {
    __extends(DynamicSummaryList, _super);
    function DynamicSummaryList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._until = new Subject();
        return _this;
    }
    DynamicSummaryList.prototype.componentDidMount = function () {
        var _this = this;
        this.props.dataState.pathChange
            .pipe(takeUntil(this._until), filter(function (event) { return event.sender != _this; }))
            .subscribe(function () { return _this.forceUpdate(); });
    };
    DynamicSummaryList.prototype.componentWillUnmount = function () {
        this._until.next();
        this._until.complete();
    };
    DynamicSummaryList.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null, this.props.control.items
            .map(function (summaryColumn, index) { return React.createElement(Table, { key: index },
            React.createElement(TableBody, null, summaryColumn
                .map(function (row, index) { return React.createElement(TableRow, { key: index },
                React.createElement(TableCell, null, row.label),
                React.createElement(TableCell, null, _this.props.dataState.get(row.path))); }))); }));
    };
    return DynamicSummaryList;
}(React.Component));
export default DynamicSummaryList;
//# sourceMappingURL=SummaryList.js.map